<a routerLink="">
    <div class = "col-6 confirmation">

    <h2>Thank You!</h2>
        If you provided a valid email address, 
        you will receive email communications about your request.
    <div class="border-line"></div>
        <p></p>
    </div>
</a>